export default "__VITE_ASSET__7d416f3a__"